import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaBriefcase, FaUserCheck, FaEnvelope, FaCalendarCheck, FaFileSignature, FaUserCircle, FaSignOutAlt, FaCog, FaList } from "react-icons/fa";
import "../styles/RecruiterDashboard.css";

export default function RecruiterActionPage() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [postedJobs, setPostedJobs] = useState([]);
  //const [userEmail, setUserEmail] = useState("");

  {/*useEffect(() => {
    // Example: Fetch from localStorage after login
    const storedEmail = localStorage.getItem("recruiterEmail") || "Girija@compuet.com";
    setUserEmail(storedEmail);

    // ✅ Fetch posted jobs from localStorage
    const savedJobs = JSON.parse(localStorage.getItem("postedJobs")) || [];
    setPostedJobs(savedJobs);
  }, []); */}

  useEffect(() => {
    // Example: Fetch from localStorage after login
    {/*const storedEmail = localStorage.getItem("recruiterEmail") || "Girija@compuet.com";
    setUserEmail(storedEmail);*/}
    const recruiterData = JSON.parse(localStorage.getItem("recruiterInfo"));
        if (recruiterData && recruiterData.name) {
          setUserEmail(recruiterData.name);
        } else {
          const storedEmail = localStorage.getItem("recruiterEmail");
          setUserEmail(storedEmail || "U");
        }
  }, []);


  const actions = [
    { label: "Post a New Job", icon: <FaBriefcase />, path: "/post-job" },
    { label: "Posted Job List", icon: <FaList />, path: "/posted-jobList" },
    { label: "Applications Tracking / View", icon: <FaUserCheck />, path: "/applicants" },
    { label: "Contact Candidates", icon: <FaEnvelope />, path: "/contact-candidates" },
    { label: "Interview Scheduling", icon: <FaCalendarCheck />, path: "/interview-scheduling" },
    { label: "Offer Management", icon: <FaFileSignature />, path: "/offer-management" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("recruiterEmail");
    navigate("/");
  };

  //const userInitial = userEmail ? userEmail.charAt(0).toUpperCase() : "U";
  const userInitial = userEmail
  ? userEmail.trim().charAt(0).toUpperCase()
  : "U";

  return (
    <div className="dashboard-container">
      {/* ===== HEADER ===== */}
      <div className="dashboard-header">
        <h2 className="dashboard-title">Recruiter Dashboard</h2>

        <div
          className="user-profile"
          onClick={() => setShowMenu(!showMenu)}
        >
          <div className="user-avatar">{userInitial}</div>
          {/*<span className="user-name">{userEmail}</span> */}

          {showMenu && (
            <div className="dropdown-menu">
              <p onClick={() => navigate("/recruiter-profile")}>
                <FaCog /> Profile Settings
              </p>
              <p onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </p>
            </div>
          )}
        </div>
      </div>

      <p className="dashboard-subtext">Select an action to continue</p>
      <div className="action-grid">
        {actions.map((action, index) => (
          <div
            key={index}
            className="action-card"
            onClick={() => navigate(action.path)}
          >
            <div className="icon">{action.icon}</div>
            <p>{action.label}</p>
          </div>
        ))}
      </div>

      {/* ===== POSTED JOBS SECTION ===== 
      <div className="posted-jobs-section">
        <h3 className="section-heading">Your Posted Jobs</h3>
        {postedJobs.length === 0 ? (
          <p className="no-jobs">No jobs posted yet.</p>
        ) : (
          <div className="posted-jobs-list">
            {postedJobs.map((job, index) => (
              <div key={index} className="job-card">
                <div className="job-card-header">
                  <h4>{job.jobTitle}</h4>
                  <span className="job-type">{job.jobType}</span>
                </div>
                <p className="job-location">{job.location}</p>
                <p className="job-salary">
                  💰 {job.salaryRange || "Salary not specified"}
                </p>
                <button
                  className="view-job-btn"
                  onClick={() => navigate(`/job/${index}`)}
                >
                  View Details
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      */}
    </div>
  );
}
